import getWithToken from './base/get-with-token'

const getNotificationsUnRead = () => getWithToken(`/list-notifications-unread`)()

export default getNotificationsUnRead